// @ts-nocheck
/**
 * CSRD API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { EntryStatus } from './entryStatus';
import { ParametersView } from './parametersView';


export interface EmissionPointsWithParametersView { 
    /**
     * The EmissionPoint primary key
     */
    id: number;
    /**
     * The EmissionPoint idTool
     */
    idTool: number;
    /**
     * The EmissionPoint name
     */
    name: string;
    /**
     * The EmissionPoint code
     */
    code: string;
    /**
     * The EmissionPoint parameterType
     */
    parameterType: EmissionPointsWithParametersView.ParameterTypeEnum;
    /**
     * The EmissionPoint parameters
     */
    parameters: Array<ParametersView>;
    status: EntryStatus;
}
export namespace EmissionPointsWithParametersView {
    export type ParameterTypeEnum = 'air' | 'water_intake' | 'water_discharge' | 'residue' | 'energy';
    export const ParameterTypeEnum = {
        air: 'air' as ParameterTypeEnum,
        water_intake: 'water_intake' as ParameterTypeEnum,
        water_discharge: 'water_discharge' as ParameterTypeEnum,
        residue: 'residue' as ParameterTypeEnum,
        energy: 'energy' as ParameterTypeEnum
    };
}


